import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import { BZ2_FACET_P_PRICE, BZ2_FILTER_PRICE_MAX, BZ2_FILTER_PRICE_MIN } from 'mk/autogenerated/translations/PriceFacet.2b06f55924ee34003b8d82b2cd1aea2d'
import { formatPrice } from 'mk/bazaar/common/formatters';
import PriceFacetDropdown, { PriceType } from 'mk2/apps/bazaar/components/PriceFacetDropdown';
import { Modal } from 'mk2/components/Modal';
import React from 'react';
import styles from './PriceFacet.mscss';

export interface OwnProps {
    className?: string;
    isMobile: boolean;
    min?: number;
    max?: number;
    opened?: boolean;
    dimmed?: boolean;

    onToggle();
    onClear();
    onChange(type: PriceType, value: number);
}

type Props = OwnProps;

const PriceFacet: React.FunctionComponent<Props> = ({
    className,
    isMobile,
    min,
    max,
    opened = false,
    dimmed = false,
    onChange,
    onToggle,
    onClear,
}) => {
    const isPriceSet = min || min === 0 || max || max === 0;

    return (
        <div
            className={cx(
                styles.PriceFacet,
                className,
                opened ? styles['PriceFacet--opened'] : styles['PriceFacet--closed'],
            )}
        >
            <div className={cx(styles.PriceFacet__shadow, opened && styles['PriceFacet__shadow--active'])} />
            {isPriceSet && !opened && (
                <div className={styles.PriceFacet__clear} onClick={onClear}>
                    <div className={styles.PriceFacet__clear__icon}>
                        <FontAwesomeIcon icon={faTimesCircle} />
                    </div>
                </div>
            )}
            <div
                className={cx(
                    styles.PriceFacet__wrapper,
                    opened && styles['PriceFacet__wrapper--opened'],
                    isPriceSet && !opened && styles['PriceFacet__wrapper--hasValue'],
                )}
                onClick={onToggle}
            >
                {dimmed && <div className={styles.PriceFacet__dimmed} />}
                <div className={cx(styles.PriceFacet__label, isPriceSet && styles['PriceFacet__label--selected'])}>
                    <span>{isPriceSet ? formattedPrice(min, max) : BZ2_FACET_P_PRICE}</span>
                    <div className={styles.PriceFacet__triangle} />
                </div>
            </div>
            {isMobile ? (// this should fix iphone safari bug with invisible header
                <Modal className={styles.PriceFacet__dropdown} show={opened} backdrop={false}>
                    <PriceFacetDropdown min={min} max={max} onChange={onChange} onClose={onToggle} />
                </Modal>
            ) : opened ? (
                <div className={styles.PriceFacet__dropdown}>
                    <PriceFacetDropdown min={min} max={max} onChange={onChange} onClose={onToggle} />
                </div>
            ) : null}
        </div>
    );
};

PriceFacet.displayName = 'PriceFacet';

export default React.memo<Props>(PriceFacet);

function formattedPrice(min: number, max: number) {
    if (!min && min !== 0) {
        return (max !== 0 ? BZ2_FILTER_PRICE_MAX + ' ' : '') + formatPrice(max, true);
    } else if (!max && max !== 0) {
        return BZ2_FILTER_PRICE_MIN + ' ' + formatPrice(min, true);
    } else {
        return formatPrice(min, true) + ' - ' + formatPrice(max, true);
    }
}
